import { lazy } from 'react'

import { Routes } from '@infrastructure/navigation/routes'
import verticalNavigation from '@infrastructure/navigation/vertical'

import { name } from '../repository'

const basePath = '/recommendation-prototypes'

Routes.push({
  path: basePath,
  component: lazy(() => import('../components/RecommendationPrototypesPage')),
  meta: {
    authRoute: true
  }
})

verticalNavigation.prototypesSection.children.push({
  id: name,
  title: 'Рекомендації',
  navLink: basePath
})
